<template>
  <BasicTile @click="tileClicked"  class="square-tile w-100" align="center" v-interact>
    <slot name="badge"></slot>
    <slot name="icon"></slot>

    <v-row no-gutters class="d-flex flex-column my-3">

      <slot name="details"></slot>

    </v-row>





    <slot name="actions"></slot>




    <div class="w-100">
      <slot name="append-bottom"></slot>
    </div>





  </BasicTile>
</template>



<script>

import BasicTile from '@/components/Tiles/Basic-Tile.vue';

export default {
  name: "SquaredTile",
  components: {
    BasicTile,
  },
  setup(props, { emit }) {
    const tileClicked = () => {
      emit('click');
    }

    return {
      tileClicked,
    }
  }
}

</script>